import type { Question } from "@/domain/entities";
import { Button } from "../Button";
import { useLocale } from "../../i18n/LocaleProvider";
import styles from "./questions.module.css";

type ScaleQuestion = Extract<Question, { type: "scale" }>;

interface Props {
  question: ScaleQuestion;
  value: number | undefined;
  onSubmit: (value: number) => void;
}

export function ScaleInput({ question, value, onSubmit }: Props) {
  const { pick } = useLocale();
  const steps = Array.from({ length: question.max - question.min + 1 }, (_, i) => question.min + i);
  return (
    <div className={styles.stack}>
      <div className={styles.grid}>
        {steps.map((step) => (
          <Button key={step} selected={value === step} onClick={() => onSubmit(step)}>{step}</Button>
        ))}
      </div>
      {question.labels && (
        <div className={styles.labels}>
          <span>{pick(question.labels.min)}</span>
          <span>{pick(question.labels.max)}</span>
        </div>
      )}
    </div>
  );
}
